import { useQuery } from '@tanstack/react-query';
import { getReviewsSectionsDataApi } from 'api/performanceReview';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getReviewFormsList } from 'services/performanceReview';

const getData = async () => {
  try {
    const res = await getReviewsSectionsDataApi();
    return res.entity;
  } catch (err) {
    console.error('Error fetching Reviews sections data : ', err);
  }
  return null;
};

const useReviewSectionsData = () => useQuery([REACT_QUERY_KEYS.ReviewSections], () => getData());

export const useReviewFormsList = ({ reviewCycleId, sectionId, reactQueryKey }) =>
  useQuery(
    [reactQueryKey, sectionId, reviewCycleId],
    () =>
      getReviewFormsList({
        limit: 5000,
        offset: 0,
        includeCount: true,
        sectionId,
        reviewCycleId,
      }),
    { enabled: !!sectionId }
  );

export default useReviewSectionsData;
